import {observable, action} from 'mobx';
import {makeAutoObservable} from 'mobx';
import {DecisionInput} from "src/app/model/DecisionInput";

class ReviewDecisionStore {
    constructor() {
        makeAutoObservable(this);
    }

    @observable value: DecisionInput = {
        reason: '',
        comment: '',
        reviewStatus:'',
        reviewResult: "",
        auditorInputs: new Map<string, string>()
    };

    @action updateValue(newValue: DecisionInput) {
        this.value = newValue;
    }

    @action resetValue() {
        this.value = {
            reason: '',
            comment: '',
            reviewResult: '',
            reviewStatus: '',
            auditorInputs: new Map<string, string>()
        };
    }
}

export default new ReviewDecisionStore();